import { gql } from '@apollo/client';
export const StaffingSettings = gql `
    fragment StaffingSettings on StaffingSettings {
        siteSetId
        employeeWorkDay
        employeeWorkDayMin
        holidayLeaveRangeV2
        absentLeaveRangeV2
        sickLeaveRangeV2
        childSickLeaveRangeV2
        holidayApprovalRequired
        absentApprovalRequired
        sickApprovalRequired
        childSickApprovalRequired
        holidayIsPaid
        absentIsPaid
        sickIsPaid
        childSickIsPaid
        defaultWorkTagId
        holidayAllowance
        subTypeIsRequired
        subTypeIsRestricted
        absenceCounting
        allowStaffAbsencesOnWeekend
    }
`;
